/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Landing_Studio_BalanceInputs */

const en_landing_studio_balance = /** @type {(inputs: Landing_Studio_BalanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Balance: ${i?.credits} credits`)
};

const zh_landing_studio_balance = /** @type {(inputs: Landing_Studio_BalanceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`余额：${i?.credits} 积分`)
};

/**
* | output |
* | --- |
* | "Balance: {credits} credits" |
*
* @param {Landing_Studio_BalanceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_balance = /** @type {((inputs: Landing_Studio_BalanceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_BalanceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_balance(inputs)
	return zh_landing_studio_balance(inputs)
});
export { landing_studio_balance as "landing.studio.balance" }